import React from 'react';
import PropTypes from 'prop-types';

const TabContainer = props => {
  return (
    <div {...props}>
      {props.children}
    </div>
  );
}

export default class SwipeableTab extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    tabLabel: PropTypes.string,
    tabClassName: PropTypes.string,
    tabStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    tabComponent: PropTypes.node,
    tabProps: PropTypes.object,
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    containerProps: PropTypes.object
  }

  static defaultProps = {
    tabComponentProps: {}
  }

  render() {
    const {containerClassName, containerStyle, containerProps} = this.props;

    return (
      <TabContainer
        className={containerClassName}
        style={containerStyle}
        {...containerProps}
      >
        {this.props.children}
      </TabContainer>
    );
  }
}
